// `Models` is the ambient namespace from src/models/index.d.ts (not a module import).
// `closeChat` (actions.tsx) resolves with the updated ChatMetadata when the close went through
// (including the 66004 already-closed case, where PST still finishes its half) and resolves with
// the caught error when admission or the metadata close refused it. It never rejects, so callers
// must inspect the value: leaving the tile on a refused close drops the specialist's view of a
// chat that is still open server-side and unmounts the patient-name-required alert with it.
export function chatCloseSucceeded(result: unknown): result is Models.ChatMetadata {
    if (!result || typeof result !== 'object' || result instanceof Error) return false
    const value = result as { channel_name?: unknown; errors?: unknown }
    if (Array.isArray(value.errors)) return false
    return typeof value.channel_name === 'string' && value.channel_name.length > 0
}
